import { ComponentProps } from 'react';
import { Checkbox } from '../../atoms/checkbox/checkbox';
import { cardStyles, Typography } from '../../ui';
import { twMerge } from 'tailwind-merge';

type StatementCheckboxProps = {
  label: string;
  className?: string;
} & Omit<ComponentProps<typeof Checkbox>, 'children' | 'className'>;

export function StatementCheckbox(Props: StatementCheckboxProps) {
  const { label, className, ...rest } = Props;
  return (
    <div
      className={cardStyles({ variant: 'outlined', className: twMerge('flex p-24', className) })}
    >
      <Checkbox {...rest}>
        <Typography
          as="p"
          variant="body-s"
          weight="regular"
          className="ml-16 text-grayscale300"
        >
          {label}
        </Typography>
      </Checkbox>
    </div>
  );
}
